export default {
  baseUrl: "https://artifinda-test-aaf09bed12f5.herokuapp.com/",
  baseurl: "https://artifinda-test-aaf09bed12f5.herokuapp.com/",
  

};
